export default "__VITE_ASSET__gkuH384i__"